exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-hideIcon-2y-bj{stroke:var(--color-night-gray9);width:16px;align-self:center;cursor:pointer}", ""]);

// exports
exports.locals = {
	"hideIcon": "style-cssmodule-hideIcon-2y-bj"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./components/inputs/Input/style.cssmodule.css
// module id = 2533
// module chunks = 121